import React, { useState } from "react";
import stylelist from "stylelist";

const RadioButton = (props) => {
    return <label htmlFor={props.name} onClick={()=>props.setActive(props.name)}>
        <div style={{position: "relative"}} className={stylelist('iradio_flat-grey',[props.active===props.name,'checked'])}>
            <input style={{position: "absolute", opacity: 0}} tabIndex="1"
                   id={props.name} name={props.name} className="icheck"
                   type="radio"/>
            <ins
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    display: "block",
                    width: "100%",
                    height: "100%",
                    margin: 0,
                    padding: 0,
                    background: "rgb(255, 255, 255) none repeat scroll 0% 0%, border: 0px none",
                    opacity: 0,
                    cursor: "pointer"
                }}
                className="iCheck-helper"
            />
        </div>
        {props.name}
    </label>
}

export default RadioButton;